module.exports = __webpack_public_path__ + "img/american-express.8fe3c80.svg";